import { useState } from 'react';
import { haptics } from '../../telegram';

const THESES = [
  'Обыграл сильных — растёшь быстро. Уступил слабым — теряешь больше.',
  'Рейтинг живёт всю карьеру и не обнуляется с сезоном.',
  'Пропустил 4 игры подряд — рейтинг понемногу «ржавеет». Любой визит останавливает.',
  'Достижения «Мастерство» — по пику: полученное не отнимется.',
];

/** Аккордеон «Как работает личный рейтинг» (свёрнут по умолчанию). */
export function RatingHowItWorks() {
  const [open, setOpen] = useState(false);
  return (
    <div className={`rating-how ${open ? 'open' : ''}`}>
      <button
        className="rating-how-head"
        onClick={() => {
          haptics.tap();
          setOpen((v) => !v);
        }}
      >
        <span>Как работает личный рейтинг</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" className="chev">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {open && (
        <ol className="rating-how-list">
          {THESES.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ol>
      )}
    </div>
  );
}
